export function commerceFlag(value) {
  if (value === true || value === 1 || ["true", "1"].includes(String(value).trim().toLowerCase()))
    return true;
  if (value === false || value === 0 || ["false", "0"].includes(String(value).trim().toLowerCase()))
    return false;
  return null;
}
const text = (value) => (typeof value === "string" ? value.trim() : "");
export function commerceList(response, available = false) {
  if (!Array.isArray(response?.response))
    throw new Error("La respuesta no contiene una lista válida de comercios.");
  return response.response
    .map((row) => {
      if (!row || row.idcommerce === null || row.idcommerce === undefined)
        throw new Error("El comercio recibido no tiene un ID válido.");
      return {
        id: row.idcommerce,
        nombre: text(available ? row.name : row.namecomercio),
        ...(available
          ? {}
          : {
              activo: commerceFlag(row.activo),
              aperturaCB: commerceFlag(row.aperturacb),
              integracion: text(row.integracion),
              tipoComercio: text(row.tipocomercio),
              tipoIntegracion: text(row.tipointegracion),
            }),
      };
    })
    .sort((a, b) => a.nombre.localeCompare(b.nombre, "es", { numeric: true, sensitivity: "base" }));
}
export function commerceAttributes(response) {
  const value = response?.response;
  if (!value || typeof value !== "object" || Array.isArray(value))
    throw new Error("Los atributos del comercio no tienen un formato válido.");
  const arrays = {
    tipo_comercio: value.tipo_comercio,
    tipo_integración: value.tipo_integración ?? value.tipo_integracion,
    integracion: value.integracion,
  };
  for (const [key, options] of Object.entries(arrays)) {
    if (!Array.isArray(options) || options.some((option) => typeof option !== "string"))
      throw new Error(`No se recibieron las opciones de ${key}.`);
  }
  return arrays;
}
export function initialCommerceForm(row) {
  return row
    ? {
        idcommerce: String(row.id),
        namecomercio: row.nombre,
        tipocomercio: row.tipoComercio || "",
        tipointegracion: row.tipoIntegracion || "",
        integracion: row.integracion || "",
        activo: commerceFlag(row.activo),
        aperturacb: commerceFlag(row.aperturaCB),
      }
    : {
        idcommerce: "",
        namecomercio: "",
        tipocomercio: "",
        tipointegracion: "",
        integracion: "",
        activo: true,
        aperturacb: false,
      };
}
export function validateCommerceForm(form) {
  const errors = {};
  if (
    !/^\d+$/.test(String(form.idcommerce)) ||
    !Number.isSafeInteger(Number(form.idcommerce)) ||
    Number(form.idcommerce) <= 0
  )
    errors.idcommerce = "Selecciona un comercio válido.";
  for (const [key, label] of [
    ["namecomercio", "Nombre"],
    ["tipocomercio", "Tipo de comercio"],
    ["tipointegracion", "Tipo de integración"],
    ["integracion", "Integración"],
  ]) {
    if (!text(form[key])) errors[key] = `${label}: campo requerido.`;
  }
  if (commerceFlag(form.activo) === null) errors.activo = "Define el estado del comercio.";
  if (commerceFlag(form.aperturacb) === null) errors.aperturacb = "Define la apertura CB.";
  return errors;
}
export function commercePayload(form) {
  const errors = validateCommerceForm(form);
  if (Object.keys(errors).length) throw new Error(Object.values(errors)[0]);
  return {
    idcommerce: Number(form.idcommerce),
    name: form.namecomercio.trim(),
    status: commerceFlag(form.activo),
    type: form.tipocomercio,
    integration_type: form.tipointegracion,
    integration: form.integracion,
    open_cb: commerceFlag(form.aperturacb),
  };
}
const responseParts = (response) =>
  [response, response?.response].filter(
    (value) => value && typeof value === "object" && !Array.isArray(value)
  );
const numericCode = (value) =>
  (typeof value === "number" || (typeof value === "string" && value.trim())) &&
  Number.isFinite(Number(value))
    ? Number(value)
    : null;
const successfulCode = (code) => code === 0 || (code >= 200 && code < 300);
export function commerceWriteRejected(response) {
  return (
    response?.response === false ||
    responseParts(response).some((value) => {
      const code = numericCode(value.code),
        status = numericCode(value.status);
      return (
        value.success === false ||
        value.error ||
        (code !== null && !successfulCode(code)) ||
        (status !== null && status >= 100 && !(status >= 200 && status < 300))
      );
    })
  );
}
export function commerceWriteSucceeded(response) {
  if (!response || typeof response !== "object" || commerceWriteRejected(response)) return false;
  return (
    ["succesful", "successful", "success"].includes(response.msm) ||
    responseParts(response).some((value) => {
      const code = numericCode(value.code),
        status = numericCode(value.status);
      return (
        value.success === true ||
        (code !== null && successfulCode(code)) ||
        (status !== null && status >= 200 && status < 300)
      );
    })
  );
}
export function filterCommerces(rows, filters) {
  const query = filters.busqueda.trim().toLowerCase();
  return rows.filter(
    (row) =>
      (!query ||
        [row.id, row.nombre, row.integracion, row.tipoComercio, row.tipoIntegracion].some((value) =>
          String(value ?? "")
            .toLowerCase()
            .includes(query)
        )) &&
      (filters.tipo === "todos" || row.tipoComercio === filters.tipo) &&
      (filters.activo === "todos" ||
        (filters.activo === "activos" && row.activo === true) ||
        (filters.activo === "inactivos" && row.activo === false) ||
        (filters.activo === "desconocidos" && row.activo === null))
  );
}
export function commerceStats(rows) {
  return {
    totalComercios: rows.length,
    activos: rows.filter((row) => row.activo === true).length,
    inactivos: rows.filter((row) => row.activo === false).length,
    desconocidos: rows.filter((row) => row.activo === null).length,
    conAperturaCB: rows.filter((row) => row.aperturaCB === true).length,
  };
}
